module.exports = __webpack_public_path__ + "img/cross_icon.f46317ed.svg";